// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-3NYNT","shareBoxTitle":"jgp-3jMFD","socialIconList":"jgp-t6Y8Q","listItem":"jgp-5jHBj"};